import React from "react";
import PropTypes from "prop-types";
import StrokeProperties from "./StrokeProperties";
import FillProperties from "./FillProperties";
import { Grid } from "@mui/material";
import { getDir } from "orion-components/i18n/Config/selector";
import { useSelector } from "react-redux";
import { Translate } from "orion-components/i18n";

const StyleProperties = ({ shapeType }) => {
	const dir = useSelector((state) => getDir(state));
	return (
		<div
			style={{
				marginTop: 36,
				...(dir === "ltr" && { marginLeft: 20 }),
				...(dir === "rtl" && { marginRight: 20 })
			}}
		>
			<p
				style={{
					fontSize: 14,
					letterSpacing: 0,
					color: "#FFFFFF",
					marginBottom: 15,
					fontFamily: "roboto"
				}}
			>
				<Translate value="global.sharedComponents.shapeEditor.components.shared.styleProperties.style" />
			</p>
			<div>
				<Grid container>
					{shapeType === "polygon" || shapeType === "rectangle" || shapeType === "circle" ? (
						<Grid item xs={6}>
							<FillProperties shapeType={shapeType} />
						</Grid>
					) : null}
					<Grid item xs={6}>
						<StrokeProperties shapeType={shapeType} />
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

StyleProperties.propTypes = {
	shapeType: PropTypes.string.isRequired
};

export default StyleProperties;
